import surveyCoreStyle from "survey-core/survey-core.min.css?raw";
import surveyCreatorCoreStyle from "survey-creator-core/survey-creator-core.min.css?raw";
import builder from "./builder.css?raw";
import { getLocaleStrings, ICreatorOptions } from "survey-creator-core";
import { useState } from "react";
import { SurveyCreator, SurveyCreatorComponent } from "survey-creator-react";
import {
  registerDefaults,
  registerEventHandlers,
  registerResponsiveStyles,
  registerSurveyExtensions,
} from "@rumbledirect/survey";
import { ConfigProvider } from "antd";
import "survey-core/i18n/dutch";
import { UseMutationResult } from "@tanstack/react-query";
import { convertSurveyThemeToAntdConfig } from "../helpers/theme";
import { axiosInstance } from "@/lib/api/client";
import ShadowWrapper from "@/pages/admin/form-configurations/components/ShadowWrapper";

const defaultCreatorOptions: ICreatorOptions = {
  collapseOnDrag: true,
  showThemeTab: true,
  showTranslationTab: true,
  questionTypes: [
    "appointment-time-slot",
    "text",
    "comment",
    "licensePlate",
    "dropdown",
    "panel",
    "selector",
    "radiogroup",
    "checkbox",
    "checkboxGroupLarge",
  ],
};

registerSurveyExtensions();
registerResponsiveStyles();

const locale = getLocaleStrings("en");
locale.qt["appointment-time-slot"] = "Appointment Time Slot";
locale.qt["licensePlate"] = "License plate";
locale.qt["checkboxGroupLarge"] = "Checkboxes Large";
locale.qt["selector"] = "Selector";

export const Builder = (props: {
  formConfiguration: object;
  themeConfiguration: object;
  updateFormConfigurationMutation: UseMutationResult<null, Error, any, unknown>;
  updateFormConfigurationThemeMutation: UseMutationResult<
    null,
    Error,
    any,
    unknown
  >;
}) => {
  const [tokens, setTokens] = useState({});

  const [creator] = useState(() => {
    const c = new SurveyCreator(defaultCreatorOptions);
    if (props.formConfiguration) c.JSON = props.formConfiguration;
    if (props.themeConfiguration) {
      c.theme = props.themeConfiguration;
      setTokens(convertSurveyThemeToAntdConfig(c.theme));
    }
    return c;
  });

  creator.saveSurveyFunc = async () => {
    props.updateFormConfigurationMutation.mutate(creator.JSON);
  };

  creator.saveThemeFunc = async () => {
    props.updateFormConfigurationThemeMutation.mutate(creator.theme);
    setTokens(convertSurveyThemeToAntdConfig(creator.theme));
  };

  creator.onSurveyInstanceCreated.add((_, options) => {
    registerDefaults(options.survey, axiosInstance);
    registerEventHandlers(options.survey);
  });

  return (
    <ShadowWrapper styles={[surveyCoreStyle, surveyCreatorCoreStyle, builder]}>
      <ConfigProvider theme={tokens}>
        <SurveyCreatorComponent creator={creator} />
      </ConfigProvider>
    </ShadowWrapper>
  );
};
